import React, { memo, useMemo } from "react";

const ListMenu = ({ userType }) => {
  const columns = useMemo(() => {
    const baseColumns = [
      "Username",
      "Credit",
      "Current",
      "Booked",
      "Net Booked",
      "Trade",
      "Close Only",
      "Status",
      "Ip Address",
      "Created Date",
      "Last Login",
      "ACTION",
    ];

    if (userType === 1) {
      // For admin: add both Super, Master, and one extra empty column
      return ["Super", "Master", ...baseColumns, "CLEAR", "COPY"];
    } else if (userType === 2) {
      // For super: add Master only
      return ["Master", ...baseColumns, "COPY"];
    } else {
      // For others (master, broker, user)
       return [...baseColumns, "COPY"];
    }
  }, [userType]);

  return (
    <div className="menuContainer primary white">
      {columns.map((label, index) => (
        <div
          key={index}
          className={
            label === "Ip Address" ||
            label === "Created Date" ||
            label === "Last Login"
              ? "menuName small white"
              : label === "Super" ||
                label === "Master" ||
                label === "Username"
              ? "menuUsername"
              : "menuName"
          }
        >
          {label}
        </div>
      ))}
    </div>
  );
};

export default memo(ListMenu);
